module.exports = __webpack_public_path__ + "img/frost_wolf_small.55a58dc0.png";